var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",class:{ active: _vm.flag },on:{"click":function($event){return _vm.changeShow($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }